const BASE_URL = "https://api.themoviedb.org/3/";
const IMAGE_URL = "https://image.tmdb.org/t/p/w780/"
const API_KEY = "f878e891c9cf5b3526916573122379d5";

export {BASE_URL, API_KEY, IMAGE_URL};